import { Request } from "@xt/xtbase";

const { XtAxios } = Request;
const URL = "/xt-lever/";

export function get_marketConfig(config?) {
  return XtAxios.get(URL + "marketConfig", config);
}

export function get_accountOverview(marketName, config?) {
  return XtAxios.get(URL + `account/${marketName}/overview`, config);
}

export function get_tokenUserKey(config?) {
  return XtAxios.get(URL + "token/userKey", config);
}

export function post_loan({ market, coin, amount, trace }, config) {
  return XtAxios.post(URL + `loan/${market}/${coin}?amount=${amount}&trace=${trace}`, null, config);
}

export function post_repayLoan({ market, coin, amount, trace }, config) {
  return XtAxios.post(URL + `repayLoan/${market}/${coin}?amount=${amount}&trace=${trace}`, null, config);
}
